/**
 * ChatSlider handles the sliding of the video view and the chat.
 * The HTML for this component is in PlayerChat.html
 */
export class ChatSlider {
	constructor(el, $) {	
		this.el = el;
		this.$ = $;
		this.state = 1;

		this.$.slideopen.addEventListener(`click`, (evt)=>{
			this.open(evt);
		});
		this.$.slideclose.addEventListener(`click`, (evt)=>{
			this.close(evt);
		})
		this.playerChat = this.findPlayerChat(el);

	}
	findPlayerChat(el) {
		if (null==el || typeof el == `undefined`) {
			return null;
		}
		if (el.classList.contains(`PlayerChat`)) {
			return el;
		}
		return this.findPlayerChat(el.parentElement);
	}
	open(evt) {
		evt.preventDefault(); evt.stopPropagation();
		this.setState(this.state + 1);
	}
	close(evt) {
		evt.preventDefault(); evt.stopPropagation();
		this.setState(this.state - 1);
	}
	setState(state) {
		console.log(`Setting ChatSlider state to `, state);
		if (0>state || 2<state || state==this.state) {
			return;	// ignore attempts to set too open or too closed
		}
		if (!this.playerChat) {
			console.log(`cannot setState for ChatSlider - failed to find PlayerChat node`);
			return;
		}
		this.playerChat.classList.remove(this.classForState(this.state));
		this.playerChat.classList.add(this.classForState(state));
		this.state = state;
	}
	classForState(state) {
		switch (state) {
			case 0:
			return `chat-none`;
			case 1:
			return `chat-show`;
			case 2:
			return `chat-full`;
		}
		return ``;
	}
}